import { render, staticRenderFns } from "./ClubLobbies.vue?vue&type=template&id=2f73d40a&"
import script from "./ClubLobbies.vue?vue&type=script&lang=js&"
export * from "./ClubLobbies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClubLobbies.vue"
export default component.exports